window.billingModel = {

    configuration: null,

    processBillingData: function(data){

       var headerRequest = billingModel.getBillingHeaderFromTaskId(data.party_id, data.party_type_id);
       var linesRequest = billingModel.getBillingLinesFromTaskId(data.episode_id);

        $.when(headerRequest, linesRequest).done(function(headerResponse, detailResponse){

            if (detailResponse[0] == null){
                bootbox.alert("O episódio não tem actos para serem faturados!");
                return false;
            }

            if (headerResponse[0].data.predefined_document_type_id == null || headerResponse[0].data.predefined_document_type_id === -1 ||
                headerResponse[0].data.predefined_payment_condition_id == null || headerResponse[0].data.predefined_payment_condition_id === -1 ||
                headerResponse[0].data.predefined_payment_method_id == null || headerResponse[0].data.predefined_payment_method_id === -1 ||
                headerResponse[0].data.predefined_series == null || headerResponse[0].data.predefined_series === -1) {

                bootbox.alert("Dados do cliente por definir. Por favor verificar serie, documento, método e condição de pagamento! Verifique no módulo de Faturação.");
                return false;

            }

            billingModel.createSaleTransaction(headerResponse[0].data, detailResponse[0].data, notificationNS.notification);

        }).fail(function () {
            Hades.showBalloonMessage("Falha no processamento da fatura.")
        })

    },

    getBillingHeaderFromTaskId: function (partyId, partyTypeId) {

        return $.ajax({
            url: "/billing/get_customer_info",
            dataType: "json",
            type: 'GET',
            data: {mappingParty: true, id: partyId, party_type_id: partyTypeId},

            success: function (data, st, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);
            },
            error: function (data,st, xhr) {

            }
        });

    },

    getBillingLinesFromTaskId: function (taskId) {

        return $.ajax({
            url: "/patient_billing/get_patient_billing_items",
            dataType: "json",
            type: 'GET',
            data: {task_id: taskId},

            success: function (data,st, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);
            },
            error: function (data,st, xhr) {

            }
        });

    },

    createSaleTransaction: function (header, lines, callback) {

        var saleTransactionHeader = billingModel.mappingHeaderData(header);
        var saleTransactionDetail = billingModel.mappingDetailData(lines);

        var params = saleTransactionHeader;
        params.lines = JSON.stringify(saleTransactionDetail);

        $.post('/billing/save_document_ex', params, null, "json")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (!data.success === true) {
                    Hades.showBalloonMessage("Erro na criação da fatura. " + data.error, 'alert-error', 10000);

                } else {
                    if(data.submit_type == 'create'){


                        if (billingModel.configuration.filter.mb_reference){
                            billingModel.generateAtmDocPayment(data.result, callback);
                        }


                        Hades.showBalloonMessage("Fatura automaticamente processada", 'alert-success', 10000);

                    } else {
                        Hades.showBalloonMessage()
                    }
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });

    },

    mappingHeaderData: function (headerRequest) {

        var header = {};

        // populate header
        header.authorization_nr = null;
        header.currency = headerRequest.currency_id;
        header.date = moment(new Date()).format('YYYY-MM-DD');
        header.hour = moment(new Date()).format('HH:mm');
        header.document = headerRequest.predefined_document_type_id;
        header.eligibility = null;
        header.flg_has_episode_admission = false;
        header.global_discount_pct = null;
        header.invoice_change = 0.00;
        header.address = headerRequest.address;
        header.city = headerRequest.city;
        header.country_id = headerRequest.country_id;
        header.fiscal_number = headerRequest.fiscal_number;
        header.client_id = headerRequest.party_id;
        header.name = headerRequest.name;
        header.postal_code = headerRequest.postal_code;
        header.payment_condition = headerRequest.predefined_payment_condition_id;
        header.payment_method = -1;
        header.payment_methods = [];
        header.sale_transaction_id = null;
        header.series = headerRequest.predefined_series;
        header.submit_type = "create";
        header.treasury_location = null;
        header.vat = headerRequest.vat_id;

        return header;

    },

    mappingDetailData: function (linesRequest) {

        var lines = [];

        // populate lines from episode_billing_item filtered by episode context
        $.each(linesRequest, function (i, lineData) {

            var line = {};

            line.designation = lineData.item_description;
            line.discount = null;
            line.discount_type = null;
            line.episode_billing_item_id = lineData.episode_billing_item_id;
            line.item_obs = null;
            line.line_action = "I";
            line.line_id = "";
            line.motive = null;
            line.origin_line_item_id = null;
            line.origin_sale_transaction_id = null;
            line.product = lineData.item_id;
            line.product_code = lineData.item_code;
            line.product_type = lineData.item_type_id;
            line.qtd = lineData.quantity;
            line.qtd_unit_id = lineData.qty_um_id;
            line.total = lineData.price_total_numeric;
            line.unit_price = lineData.unit_price_numeric;
            line.vat = lineData.vat_id;

            lines.push(line);
        })

        return lines;
    },

    generateAtmDocPayment: function (invoice_id, callback) {

        $.ajax({
            url: '/billing/generate_atm_doc_payment',
            dataType: "json",
            type: 'POST',
            data: {invoice_id: invoice_id},

            success: function (data,st, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);
                if (data.success) {
                    callback(invoice_id, globalConstants.EXTERNAL_NOTIFICATION_INVOICE_CREATED, null);
                    Hades.hideLoading();
                }

            },
            error: function (data,st, xhr) {
                Hades.showBalloonMessage("Referência e Entidade não gerada!", 'alert-error', 10000);
                Hades.hideLoading();
            }
        });

    },

    validateAutoBilling: function (params) {

        $.get('/khis_util/get_sys_conf_json', {code: globalConstants.AUTOMATIC_EPISODE_BILLING}, null, "json")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data != null && data.enable){
                    billingModel.configuration = data;
                    billingModel.proccessClinicalInfo({episode_id: params.episode_id});
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });

    },

    proccessClinicalInfo: function (params) {

       episode.get_episode_info(params.episode_id, billingModel.processDataVerification);

    },

    processDataVerification: function (episodeData) {

        debug.log((parseInt(episodeData.wf_status_id) === parseInt(billingModel.configuration.filter.wf_status_id)
            && ($.inArray(episodeData.financial_institution_id, billingModel.configuration.filter.financial_institution_id.split(',')) >= 0)
            && ($.inArray(episodeData.appointment_type_id, billingModel.configuration.filter.appointment_type_id.split(',')) >= 0)
            && ($.inArray(episodeData.appointment_type_specificity_id, billingModel.configuration.filter.appointment_type_specificity_id.split(',')))));

        if ((parseInt(episodeData.wf_status_id) === parseInt(billingModel.configuration.filter.wf_status_id)
            && ($.inArray(episodeData.financial_institution_id, billingModel.configuration.filter.financial_institution_id.split(',')) >= 0)
            && ($.inArray(episodeData.appointment_type_id, billingModel.configuration.filter.appointment_type_id.split(',')) >= 0)
            && ($.inArray(episodeData.appointment_type_specificity_id, billingModel.configuration.filter.appointment_type_specificity_id.split(',')) >= 0)
        )
        ){

            bootbox.confirm({
                message: "Pretende faturar esta consulta?",
                buttons: {
                    confirm: {
                        label: GlobalTranslations['APP_LABEL.267'],
                        className: 'btn-success'
                    },
                    cancel: {
                        label: GlobalTranslations['APP_LABEL.165'],
                        className: 'btn-danger'
                    }
                },
                callback: function (valid) {
                    if (valid) {
                        Hades.showBalloonMessage("A processar fatura para os actos associados ao episódio.", 'alert-warning', 2000);
                        billingModel.processBillingData({party_id: episodeData.patient_id, party_type_id: globalConstants.PARTY_TYPE_CLINICAL, episode_id: episodeData.episode_id});
                    }
                }
            });

        }
        else {
            return false;
        }

    }

}